import { useAuthStore } from "@src/entities/login/model/store/authStore";
import { ReactNode, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useIsAuth } from "@src/entities/login/model/hooks/isAuth/useIsAuth";
import { CircularProgress } from "@mui/material";
import { useUserInfoMeStore } from "@src/entities/user/model/store/userInfoMeStore";
import { useGetUserInfoMe } from "@src/entities/user";
import { useNotificationStore } from "../Notification";
import { userАccountСhangesStore } from "@src/entities/user/model/store/userАccountСhangesStore";
import { tariffsStore } from "@src/entities/tariffs/model/store/tariffsStore";

import styles from "./style.module.scss";

export const ProtectendRoute = ({ children }: { children: ReactNode }) => {
  const { isAuthenticated } = useAuthStore();
  const { showAlert } = useNotificationStore();
  const setUser = useUserInfoMeStore((state) => state.setUser);
  const clearUser = useUserInfoMeStore((state) => state.clearUser);
  const clearInfo = userАccountСhangesStore((state) => state.clearInfo);
  const clearTariffs = tariffsStore((state) => state.clearTariffs);
  const clearisAuthUser = useAuthStore((state) => state.clearUser);

  const isMakeAuthRequest = sessionStorage.getItem("auth-storage") || "";

  const {
    data,
    isSuccess,
    refetch: getUserInfoMe,
    isPending: isGetUserInfoMePending,
  } = useGetUserInfoMe();

  const { mutateAsync: isAuth, isPending: isUseIsAuthPending } = useIsAuth();

  useEffect(() => {
    const initFunction = async () => {
      try {
        await isAuth();
        await getUserInfoMe();
      } catch (error: any) {
        showAlert(error.message, "error");
      }
    };

    if (isMakeAuthRequest) {
      initFunction();
    }

    return () => {
      clearUser();
      clearInfo();
      clearTariffs();
      clearisAuthUser();
      tariffsStore.persist.clearStorage();
      userАccountСhangesStore.persist.clearStorage();
    };
  }, []);

  useEffect(() => {
    if (isSuccess && data) {
      setUser(data.data);
    }
  }, [isSuccess, data, setUser]);

  const isPending = isUseIsAuthPending || isGetUserInfoMePending;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isPending) {
    return (
      <div className={styles.loader}>
        <CircularProgress />
      </div>
    );
  }

  return children;
};
